// extracted by mini-css-extract-plugin
export var scrollArea = "_pc-0";